import { Stack, Typography } from '@mui/material';
import AdvancedSection from 'components/home/AdvancedSection/AdvancedSection';
import ConfigurationsStatus from 'components/home/ConfigurationsStatus/ConfigurationsStatus';
import React from 'react';

const HomePage = () => (
	<Stack gap={4}>
		<Stack gap={0.5}>
			<Typography variant="h1">{intl.tr('home.welcome.title')}</Typography>
			<Typography variant="body1">{intl.tr('home.welcome.line')}</Typography>
		</Stack>
		<ConfigurationsStatus />
		<AdvancedSection />
	</Stack>
);

export default HomePage;
